export default __webpack_public_path__ + "3a1d41a45cb502b178c10821dfa8bb29.svg";